import React from 'react';
// import ContactForm from './ContactForm';
// import config from '../../config';
export default function Footer() {
  let year = new Date();
  year = year.getFullYear();
  year = +year === 2020 ? year : `2020 - ${year}`;
  return (
    <footer id="footer">
      <div className="inner">
        {/* <ContactForm /> */}
        <section>
          <div className="row contacts">
            <div className="col-md-6 col-sm-12">
              <div>Automatisierte Maschinenbau Gruppe в России: <br/>630009, г.Новосибирск, <br/>ул. Никитина, 20, офис 657</div>
              <div><a href='tel:+73833495266'>+7 (383) 349-52-66</a></div>
              <div>info@amgcorporation.de</div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <ul className="copyright">
                <li>&copy; {year} AMG Corporation <a href='//amgcorporation.de'>amgcorporation.de</a></li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </footer>
  );
}
